import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { type Observable, map } from 'rxjs';
import type { SuggestionsMapperService } from './base/suggestions-mapper.service';
import { SuggestionsService } from './base/suggestions.service';
import type { DadataAddress, DadataParty, DadataResponse } from './interfaces';
import type { NoMultiLangCompanyCreateRequest } from './suggestion-iterfaces';

@Injectable()
export class DadataSuggestionsService extends SuggestionsService<DadataParty, DadataAddress> {
  settings = {
    key: null,
    minLength: 10,
  };

  private readonly BASE_URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party';

  constructor(mapper: SuggestionsMapperService<DadataParty, DadataAddress>, httpClient: HttpClient, key: string) {
    super(mapper, httpClient, key);

    this.settings.key = key;
  }

  public get available(): boolean {
    return true;
  }

  getCompany(id: string): Observable<NoMultiLangCompanyCreateRequest | null> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Token ${this.settings.key}`,
    });

    return this.httpClient
      .get<DadataResponse>(this.BASE_URL, { headers, params: { query: id } })
      .pipe(map(res => this.mapper.mapCompany(res.suggestions[0]?.data as DadataParty)));
  }
}
